import { Image, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import React, { useCallback } from "react";
import { fp, spH, spV } from "utils/normalizeV2";

import { Colors } from "colors";
import { Images } from "assets";
import VText from "./VText";

const ProfileMenuItem = React.memo(({ icon, title, showLine = false, onPress, hideChevron = false, isSvg = false }) => {
    const handlePress = useCallback(() => {
        onPress();
    }, [onPress]);

    return (
        <TouchableOpacity onPress={handlePress} style={styles.menuItem}>
            {showLine && <View style={styles.activeLine} />}
            {!isSvg && <Image accessibilityLabel={`${title} Icon`} style={styles.menuItemIcon} source={icon} />}
            {isSvg && <>{icon()}</>}
            <VText style={styles.menuItemText}>{title}</VText>
            {!hideChevron && <Image accessibilityLabel="Chevron" style={styles.chevron} source={Images.greyChevron} />}
        </TouchableOpacity>
    );
});

export default ProfileMenuItem;

const styles = StyleSheet.create({
    menuItem: {
        flexDirection: "row",
        alignItems: "center",
        height: spV(75),
        paddingRight: spH(16),
        borderBottomWidth: 1,
        borderBottomColor: "#eee",
    },
    menuItemText: {
        fontSize: fp(18),
        marginLeft: spV(15),
        flex: 1,
    },
    chevron: {
        width: spH(15),
        height: spH(15),
        marginLeft: "auto",
    },
    menuItemIcon: {
        marginLeft: spH(5),
        width: spH(21),
        height: spH(21),
    },
    activeLine: {
        width: 2,
        height: spV(50),
        backgroundColor: Colors.black,
    },
});
